var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":'数说服务'}},[_c('div',[_c('div',{staticStyle:{"width":"800px","height":"600px"},attrs:{"id":"map"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }